import React from "react"
import PropTypes from "prop-types"
import { Field } from "react-final-form"
import { Form } from "react-bootstrap"
import { hasFieldError } from "@/helpers/forms/validators"
import { formatDecimalNumber, formatNumberOnly } from "@/helpers/formatters"

export const NumberField = ({ name, multipleValues = {}, defaultValue = 0, isDecimal = false }) => (
  <Field type="number" name={name} format={isDecimal ? formatDecimalNumber : formatNumberOnly}>
    {({ input, meta }) => (
      <>
        <Form.Control
          {...input}
          className="v-2"
          type="number"
          placeholder={multipleValues[name] ? "Multiple values" : defaultValue.toString()}
          isInvalid={hasFieldError(meta)}
        />

        {hasFieldError(meta) && (
          <Form.Control.Feedback type="invalid" className="mt-1">
            {meta.error}
          </Form.Control.Feedback>
        )}
      </>
    )}
  </Field>
)

NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  multipleValues: PropTypes.object,
  defaultValue: PropTypes.number,
  isDecimal: PropTypes.bool,
}
